<template>
  <div
    class="border-t border-gray-300/75 p-1 max-lg:-ml-3 max-lg:-mr-2 max-lg:bg-lexmea-gray-500 max-lg:py-0.5"
  >
    <div class="flex justify-between gap-2 text-xs">
      <div v-if="legalText?.legal_text_source">
        <span> {{ $t("legal_text.middleColumn.navigation.source") }} </span>
        <a
          v-tooltip.bottom="
            $t('legal_text.middleColumn.navigation.imported_from') +
            legalText.legal_text_source.source
          "
          class="link"
          :href="legalText.legal_text_source.url"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {{ legalText.legal_text_source.name }}
        </a>
      </div>
      <div>
        {{ $t("legal_text.middleColumn.navigation.imported") }}
        <time>{{ parseDate(legalTextParagraph.updated_at) }}</time>
      </div>
      <div v-if="firstAncestor">
        <ParagraphHistoryLink :paragraph="firstAncestor">
          {{ $t("legal_text.middleColumn.navigation.old_version_available") }}
        </ParagraphHistoryLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ILegalText } from "~/models/ILegalText";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import { parseDate } from "~/utils/dates";

type Props = {
  legalText: ILegalText;
  legalTextParagraph: ILegalTextParagraph;
};

const props = defineProps<Props>();

const firstAncestor = computed(() => {
  const ancestors = props.legalTextParagraph.ancestors;
  return ancestors ? ancestors[ancestors.length - 1] : null;
});
</script>
